import { ref, watch, computed } from '@vue/composition-api';
import flatPickr from 'vue-flatpickr-component'
import { Vietnamese } from 'flatpickr/dist/l10n/vn'
import store from '@/store';
import { showToast } from '@/@core/utils/utils';
import _ from 'lodash';

export default function useFileManager() {
  const refFileListTable = ref(null);
  const tableColumns = [
    { key: 'id', sortable: false, thAttr: { width: 40 } },
    { key: 'name', sortable: false, label: 'Tên' },
    { key: 'type', sortable: false, label: 'Loại' },
    // { key: 'file', sortable: false, label: 'File' },
    { key: 'created_by', sortable: false, label: 'Người tạo' },
    { key: 'created_at', sortable: false, label: 'Ngày tạo' },
    // { key: 'status', sortable: false, label: 'Trạng thái' },
    { key: 'mam_status', sortable: false, label: 'Trạng thái trancode' },
    {
      key: 'actions',
      label: 'Hành động',
      thAttr: { width: '200' },
      thClass: 'text-right',
      tdClass: 'text-right',
    },
  ];

  const loading = ref(false);
  const perPage = ref(10);
  const totalEntries = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const categoryId = ref(null);
  const searchQuery = ref('');
  const startDate = ref('');
  const endDate = ref('');
  const sortBy = ref('id');
  const isSortDirDesc = ref(true);
  const dataFilter = ref(null);
  const statusFilter = ref(null);
  const isPaginate = ref(1);
  const itemsData = computed({
    get() {
      return store.state.files.file_items
    },
    set(val) {
      store.dispatch('files/setState', {
        file_items: val,
      });
    },
  });
  const autoFetchFiles = computed({
    get() {
      return store.state.files.auto_fetch_files
    },
    set(val) {
      store.dispatch('files/setState', {
        auto_fetch_files: val,
      });
    },
  });
  const fileManagerData = computed(() => store.state.files.file_manager);

  const configDate = ref({
    dateFormat: 'd/m/Y',
    wrap: true,
    locale: Vietnamese, // locale for this instance only
    disableMobile: true,
  });
  const configDateRange = ref({
    dateFormat: 'd/m/Y',
    mode: 'range',
    wrap: true,
    showMonths: 2,
    locale: Vietnamese, // locale for this instance only
    disableMobile: true,
  });

  const dataMeta = computed(() => {
    const localItemsCount = refFileListTable.value ? refFileListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalEntries.value,
    };
  });

  const fetchFiles = () => {
    loading.value = true;
    store
      .dispatch('files/fetchFiles', {
        category_id: categoryId.value,
        page: currentPage.value,
        limit: perPage.value,
        keyword: searchQuery.value,
        start_date: startDate.value,
        end_date: endDate.value,
        type: fileManagerData.value ? fileManagerData.value.type : '',
      })
      .then((res) => {
        loading.value = false;
        if (res.status === 200) {
          if (res.data.code === 200) {
            // console.log('res.data', res.data);
            const items = Array.isArray(res.data.data) ? res.data.data : [];
            const { total } = res.data;
            totalEntries.value = total;
            itemsData.value = items;
          }
        }
      });
  };

  const deleteFile = (id) => {
    if (id) {
      loading.value = true;
      store.dispatch('files/destroyFile', { id })
        .then((res) => {
          loading.value = false;
          if (res.status === 200) {
            if (res.data.code === 200) {
              showToast(res.data.message, { variant: 'success' })
              fetchFiles();
            }
          } else {
            showToast(res.data.message)
          }
        });
    }
  };

  // if (autoFetchFiles.value) {
  //   fetchFiles();
  // }

  watch([currentPage, perPage, categoryId], () => {
    fetchFiles();
  });

  const statusOptions = [
    { label: 'Đã kích hoạt', id: 1 },
    { label: 'Chưa kích hoạt', id: 0 },
  ];
  const resolveStatusVariant = (status) => {
    if (status === 2) return 'warning';
    if (status === 1) return 'success';
    if (status === 0) return 'secondary';
    return 'primary';
  };
  const resolveUserStatusText = (status) => statusOptions.find((x) => x.id === status).label;

  const getCatOptions = (items) => {
    const result = [
      { id: 0, name: 'Tất cả', level: 0 },
    ];
    items.forEach((item) => {
      result.push({ id: item.id, name: item.name, level: item.level });
      if (item.childs) {
        item.childs.forEach((schild) => {
          result.push({ id: schild.id, name: `--${schild.name}`, level: schild.level });
          if (schild.childs) {
            schild.childs.forEach((schild2) => {
              result.push({ id: schild2.id, name: `----${schild2.name}`, level: schild2.level });
              if (schild2.childs) {
                schild2.childs.forEach((schild3) => {
                  result.push({ id: schild3.id, name: `----${schild3.name}`, level: schild3.level });
                  if (schild3.childs) {
                    schild3.childs.forEach((schild4) => {
                      result.push({ id: schild4.id, name: `----${schild4.name}`, level: schild4.level });
                      if (schild4.childs) {
                        schild4.childs.forEach((schild5) => {
                          result.push({ id: schild5.id, name: `----${schild5.name}`, level: schild5.level });
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });

    return result;
  }
  return {
    loading,
    tableColumns,
    perPage,
    currentPage,
    totalEntries,
    dataMeta,
    perPageOptions,
    categoryId,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refFileListTable,
    itemsData,
    fetchFiles,

    resolveStatusVariant,
    resolveUserStatusText,
    // Extra Filters
    dataFilter,
    statusFilter,
    statusOptions,
    configDate,
    configDateRange,
    getCatOptions,
    deleteFile,
    autoFetchFiles,
    startDate,
    endDate,
  };
}
